
// import Cookies from 'js-cookie';
import is from "is_js";

import { Log } from "../Log/Log.js"; //quiet
import { MessagePayload } from "../Messages/Messages.js"; // quiet

import { Environment } from "./Environment.js";
import { PermissionStatuses } from "./PermissionStatuses.js";
import { GyroMessages } from "./GyroMessages.js";
import { GyroErrors } from "./GyroErrors.js";
import { States } from "./States.js";


//==============================================================================
/**
 * handles all functionality from the iframing parent side of things
 */
const parent = ( function() {

  // init these vars, yo.
  let _elem     = undefined,           // element of child iframe
      _provider = "",                  // single provider messaging for security
      _state    = States.READY;        // library state


  //----------------------------------------------------------------------------
  const __e = ( msg ) => { throw new Error( msg ); }

  //----------------------------------------------------------------------------
  /**
   * initilizer function
   * @param  {HTMLElement}  elem      iframe element
   * @param  {string}       provider  only handle message events from this provider
   */
  const init = ( elem, provider ) =>
    {
      Log.info( "Gyro.parent", "init(), Called." );

      // state check
      if( _state !== States.READY )
        throw new Error( "library has already been initialized." );

      // set some vars
      _state    = States.INITING;
      _elem     = elem;
      _provider = provider;

      Log.debug( "Gyro.parent", "  _state:", _state );
      Log.debug( "Gyro.parent", "  _elem:", _elem );
      Log.debug( "Gyro.parent", "  _provider:", _provider );

      // Will someone think of the children (frames)? 
      Log.debug( "Gyro.parent", "  adding 'message' listener..." );
      window.addEventListener( "message", _onMessage_fromChild );

      // only work for non-desktop devices (mobile/tablets)    
      _state = is.desktop()         
             ? States.INACTIVE  
             : States.IDLE;      

      Log.debug( "Gyro.parent", "  _state:", _state );
    };

  //----------------------------------------------------------------------------
  /**
   * resets the library to be reinitialized with a new iframe and provider
   */
  const dispose = () =>
    {
      Log.info( "Gyro.parent", "dispose()" );
      Log.debug( "Gyro.parent", "  _state:", _state );

      window.removeEventListener( "message", _onMessage_fromChild );
      window.removeEventListener( "deviceorientation", _onDeviceorientation_window );

      _elem = null;
      _provider = "";
      _state = States.READY;
    };

  //----------------------------------------------------------------------------
  /**
   * starts listening for motion events and sending that shit to the child frame
   */
  const enable = () =>
    {
      Log.info( "Gyro.parent", "enable()" );
      Log.debug( "Gyro.parent", "  state:", _state );

      // make this a function since we may call it several times, one 
      // synchronously and one asynchronously
      const __done = () => 
        {
          Log.debug( "Gyro.parent", "enable(), __done(), enabling..." );
          _state = States.ENABLED;
          window.addEventListener( "deviceorientation", _onDeviceorientation_window );
          _pm( GyroMessages.ENABLED );
        };

      // eeny meeny miny mo
      switch( _state )
      {
        // all states during which a request cannot be made.
        case States.READY      : _pm( GyroMessages.ERROR, { error: GyroErrors.NOT_INITIALIZED } ); break;
        case States.INACTIVE   : _pm( GyroMessages.ERROR, { error: GyroErrors.NO_GYRO } ); break;
        case States.INITING    : _pm( GyroMessages.ERROR, { error: GyroErrors.INITIALIZING } ); break; 
        case States.REQUESTING : _pm( GyroMessages.ERROR, { error: GyroErrors.REQUESTING } ); break; 

        // the state cannot be enabled if we haven't already requested permissions.
        case States.ENABLED    : _pm( GyroMessages.ENABLED ); break;

        // we've gone through all the ways in which we can't or shouldn't 
        // enable. let's go actually enable this bitch now, shall we?
        case States.IDLE :

          Log.debug( "Gyro.parent", "  library can be enabled..." );

          Log.debug( "Gyro.parent", "  checking on permissions..." );
          Log.debug( "Gyro.parent", "  hasPermissions:", Environment.hasPermissions );
          Log.debug( "Gyro.parent", "  permissionStatus:", Environment.permissionStatus );

          // if we don't need permissions (we're on Android or <iOS13) or if 
          // iOS13+ devices still need permission...
          if( !Environment.hasPermissions || 
              Environment.permissionStatus === PermissionStatuses.GRANTED )
          {
            __done();
            return;
          }

          Log.debug( "Gyro.parent", "  requesting..." );
          _request()
            .then( () =>
              {
                Log.debug( "Gyro.parent", "enable(), _request.then()..." );
                Log.debug( "Gyro.parent", "  permissionStatus:", Environment.permissionStatus );
                switch( Environment.permissionStatus )
                {
                  case PermissionStatuses.GRANTED:
                    __done();
                    break;
                  case PermissionStatuses.DENIED:
                    _pm( GyroMessages.ERROR, { error: GyroErrors.STATUS_DENIED } );
                    _state = States.INACTIVE;
                    break;
                  default:
                    _pm( GyroMessages.ERROR, { error: GyroErrors.STATUS_UNKNOWN } );
                    _state = States.INACTIVE;                  
                }
              });
          break;

        default:
          // not a gotdamn thing.
      }
    };

  //----------------------------------------------------------------------------
  /**
   * stops listening for motion events which stops sending that shit to the
   * the child frame and clogging up the internet tubes.
   */
  const disable = () =>
    {
      Log.info( "Gyro.parent", "disable()" );

      // eeny meeny miny mo
      switch( _state )
      {
        // all states during which a request cannot be made.
        case States.READY      : _pm( GyroMessages.ERROR, { error: GyroErrors.NOT_INITIALIZED } ); break;
        case States.INACTIVE   : _pm( GyroMessages.ERROR, { error: GyroErrors.NO_GYRO } ); break;
        case States.INITING    : _pm( GyroMessages.ERROR, { error: GyroErrors.INITIALIZING } ); break; 
        case States.REQUESTING : _pm( GyroMessages.ERROR, { error: GyroErrors.REQUESTING } ); break; 

        // the state cannot be enabled if we haven't already requested permissions.
        case States.IDLE       : _pm( GyroMessages.DISABLED ); break;

        // we've gone through all the ways in which we can't or shouldn't 
        // disable. let's go actually disable this bitch now, shall we?
        case States.ENABLED :

          Log.debug( "Gyro.parent", "  can be disabled..." );
          Log.debug( "Gyro.parent", "  disabling..." );
          window.removeEventListener( "deviceorientation", _onDeviceorientation_window );
          _pm( GyroMessages.DISABLED );
          _state = States.IDLE;
          Log.debug( "Gyro.parent", "  _state:", _state );

          // ************
          first = true;
          // ************

          break;

        default:
          // not a gotdamn thing.
      }
    };


  //----------------------------------------------------------------------------
  /**
   * makes the call to and handles the response for requestion gyroscope 
   * permissions.
   */
  const _request = () => new Promise( ( resolve, reject ) => 
    {
      Log.info( "Gyro.parent", "_request()" );
      Log.debug( "Gyro.parent", "  _state:", _state );

      let prevState = _state;
      _state = States.REQUESTING;
      Log.debug( "Gyro.parent", "  new _state:", _state );

      // check for consent...
      DeviceMotionEvent.requestPermission()
        .then( ( access ) => 
          {
            Log.debug( "Gyro.parent", "_request(), requestPermission.then(), access:", access );
            Environment.permissionStatus = access;
            Log.debug( "Gyro.parent", "  permissionStatus:", Environment.permissionStatus );
          })
        .catch( () => 
          { 
            Log.debug( "Gyro.parent", "_request(), requestPermission.catch()" );
          })
        .finally( () =>
          {
            Log.debug( "Gyro.parent", "_request(), requestPermission.finally()" );
            _state = prevState;
            Log.debug( "Gyro.parent", "  new _state:", _state );
            resolve();
          });
    });


  //----------------------------------------------------------------------------
  /**
   * shortcut function for a postMessage call
   * @param {Object} payload  data obj to send
   * @param {Object} target   target window (default is parent)
   */
  let first = true;
  const _pm = ( type, data ) =>
    {
      const payload = new MessagePayload( _provider, type, data );

      // only log the first call to MOTION since it's a constant thing when it's enabled.
      if( type === GyroMessages.MOTION )
      {
        first && Log.debug( "Gyro.parent", "_pm(), payload:", payload );
        first = false;
      }
      else
        Log.debug( "Gyro.parent", "_pm(), payload:", payload );

      _elem && _elem.contentWindow && 
        _elem.contentWindow.postMessage( payload, "*" );
    };

  //----------------------------------------------------------------------------
  /**
   * handles the device orientation event by send orientation data to the child
   * @param  {DeviceOrientationEvent} evt 
   */
  
  const _onDeviceorientation_window = ( evt ) =>
    {
      // Log.debug( "Gyro.parent", "_onDeviceorientation_window(), evt:", evt );

      // make a data object to send
      let data = 
        { 
          event: {
            alpha : evt.alpha,
            beta  : evt.beta,
            gamma : evt.gamma
          }
        };

      // message in a bottle (cue Sting)
      _pm( GyroMessages.MOTION, data );
    };

  //----------------------------------------------------------------------------
  /**
   * routes the Message Event from the child to the appropriate function
   * @param  {MessageEvent} evt 
   */
  const _onMessage_fromChild = ( evt ) =>
    {
      const p = evt.data;

      // not the provider? GTFO. 
      if( p.provider !== _provider ) return;

      // no message? GTFO.
      if( !p.message ) return;

      Log.info( "Gyro.parent", "_onMessage_fromChild(), p:", p );

      // figure out wtf the message is and wtf to do with it
      switch( p.message )
      {
        case GyroMessages.ENABLE  : enable();  break;
        case GyroMessages.DISABLE : disable(); break;
      }
    }

  //============================================================================
  /**
   * all access pass to ONLY init, bummer.
   */
  return { 

    // getter
    "state"    : () => _state,
    "elem"     : () => _elem,

    // public methods
    "init"     : init,
    "dispose"  : dispose,
    "enable"   : enable,
    "disable"  : disable


  }

})();

export default parent;
